export const getYears = () => {
  const years: Array<string> = [];
  for (let i = 2026; i >= 2000; i--) {
    years.push(i + "");
  }
  return years;
};

export const names = {
  file1: "Styrets beretning",
  file2: "Årsregnskap",
  file3: "Revisjonsberetning",
  file4: "Årsmøteprotokoll",
};
